<template>
    <div class="navbar-item py-0 has-text-centered">
        <button class="button is-white" @click="$emit('information')">
            <span class="icon is-medium">
                <i class="mdi mdi-24px mdi-information-outline"></i>
            </span>
        </button>
        <button class="button is-white" @click="$emit('share')">
            <span class="icon is-medium">
                <i class="mdi mdi-24px mdi-share-variant"></i>
            </span>
        </button>
        <button
            v-if="!hideLogin && isLoggedIn"
            :class="{
                'has-text-primary': community.liked,
            }"
            class="button is-white"
            @click="
                $store.dispatch('toggleCommunityLike', { _id: community._id })
            "
        >
            <span class="icon is-medium">
                <i
                    :class="{
                        'mdi-star-outline': !community.liked,
                        'mdi-star': community.liked,
                    }"
                    class="mdi mdi-24px"
                ></i>
            </span>
        </button>
    </div>
</template>
<script>
export default {
    props: {
        hideLogin: {
            type: Boolean,
            default: false,
        },
    },
    computed: {
        community() {
            return this.$store.getters.community;
        },
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
    },
};
</script>
